export default __webpack_public_path__ + "c03df9383ab4269fb9e33a000a751dab.png";